export default {
  checkout: {
    defaultCouponError: 'This coupon is not valid',
    back: 'Go back',
    registration: 'Registration',
    login: 'Login',
    yourAccount: 'Your Account',
    createAccount: 'Register',
    checkout: 'Payment',
    done: 'Done',
    confirmOrder: 'Confirm Purchase',
    review: 'Review',
    payment: 'Payment',
    userRegistered: 'Please enter your password to log in',
    userNotRegistered: 'Create your konfetti account',
    userUnknown: 'Enter your email to get started',
    emptyCartMessage: 'You cart is empty',
    surveyTitle: 'Where did you first hear about us?',

    newsletter:
      'Yes, I would like to be informed about trends, promotions & vouchers by email newsletter. Unsubscribe at any time. (optional)',

    legalCopy:
      'With your purchase you agree to our {privacyPolicy}, {termsAndConditions} and {cancellationPolicy}. As a customer of gokonfetti.com you will receive product recommendations by mail, from which you can unsubscribe at any time via a link in the mail.',
    termsAndConditions: 'Terms and conditions',
    privacyPolicy: 'Data protection policy',
    cancellationPolicy: 'Cancellation policy',

    personalDetails: {
      loginButton: 'Log into your account',
      logoutButton: 'Log out from this account',
      fillDetails: 'or fill the details below:',
      loginMessage: 'Already registered?',
      logoutMessage: 'Not you?',
      accountPerks: 'Enjoy these perks with your free account!',
      facebookLoginButton: 'Login with Facebook',
      appleLoginButton: 'Login with Apple',
      googleLoginButton: 'Login with Google',

      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        companyName: 'Company Name (optional)',
        email: 'Email',
        password: 'Password',
      },
    },

    addedToCart: 'The item was added to your cart',

    paymentDetails: {
      paymentErrorMessage:
        "Something went wrong with your payment, please contact us at <u>+30219843293</u> or wait for us to contact you from<u>hallo{'@'}okonfetti.com</u>",
      creditCard: 'Pay with card',
      paypal: 'Pay with your PayPal account',
      balance: 'Pay with Balance',
      sepa: 'Pay with SEPA',
      form: {
        title: 'Billing Address',
        productList: 'Product list',
        invoice: 'I want to generate an invoice',
        paymentMethods: 'Payment information',
        payWithPaypal: 'Pay with your PayPal account',
        payWithSEPA: 'Pay with SEPA',
        pay: 'Confirm payment',
        payWithCard: 'Complete purchase',
        payWithGiftcard: 'Pay with gift card',
        errors: {
          name: "The card holder's name is required",
        },

        card: {
          expirationDate: 'Expiry date:',
          whereIsMyCvc: 'Where can I find my CVC?',
          keep: 'Save this card for other purchases',
          number: 'Number',
          holder: 'Holder',
          cvc: 'CVC',
        },
      },
    },

    shippingDetails: {
      title: 'Shipping',
      form: {
        firstName: 'First Name',
        apartment: 'Apartment',
        lastName: 'Last Name',
        companyName: 'Company Name (optional)',
        street: 'Address',
        streetNumber: 'Number',
        locality: 'City',
        state: 'State',
        zipcode: 'Zip code',
        country: 'Country',
        phoneNumber: 'Phone',
        additional: 'Additional information',
      },
    },

    invoiceDetails: {
      title: 'Invoice address',
      form: {
        firstName: 'First name',
        apartment: 'Apartment',
        lastName: 'Last name',
        companyName: 'Firmenname',
        street: 'Street',
        streetNumber: 'House number',
        locality: 'City',
        state: 'State',
        zipcode: 'Zip code',
        country: 'Country',
        phoneNumber: 'Phone',
        vat: 'VAT',
        sameAddressAsShipping: 'Invoice address equals shipping address',
      },
    },

    steps: {
      details: 'Setup Details',
      review: 'Review Order',
      continue: 'Continue',
    },

    stepConfirmOrder: {
      title: 'Order Details',
      subtotal: 'Subtotal',
      total: 'Total',
      iAgreeWith: 'I agree to ',
      termsAndConditions: 'Terms and conditions',
    },

    orderReview: {
      title: 'Order Review',
      personalDetails: 'Personal Details',
      shippingDetails: 'Shipping Details',
      billingAddress: 'Billing Address',
      sameAsShippingAddress: 'Same as shipping address',
      paymentMethod: 'Payment Method',
      promoCode: 'Enter voucher code',
    },

    orderSummary: {
      subtotal: 'Subtotal',
      giftboxPrice: 'Gift box',
      shippingPrice: 'Shipping',
      total: 'Total',
      items: 'Items',
      grandTotal: 'Total (VAT included)',
      balance: 'Customer credit',
      promoCode: 'Enter voucher code',
      discount: 'Discount',
      shipping: 'Shipping',
      shippingInfo:
        'Your package will be shipped by mail with *provider shipping*. The shipping costs vary bsaed on your location.',
      voucher: 'Enter gift card or voucher code',
      yourOrder: 'Your order',
    },

    termsModalTitle: 'Terms and Conditions',
    acceptTermsSpanText:
      'With your purchase you agree to our privacy policy, terms and conditions and cancellation policy. As a customer of gokonfetti.com you will receive product recommendations by mail, from which you can unsubscribe at any time via a link in the mail.',
    acceptTermsSpanTerms: 'terms and conditions',

    success: {
      title: 'Fantastic - your purchase was successful!',
      orderNo: 'Order No:',
      copy: 'A copy of your order summary has been emailed to you. If you have any questions do not hesitate to contact us.',
      orders: 'Go to your orders',
      addToCalendar: 'Add to calendar',
      homeButton: 'Home',
      referralInfo: {
        title: 'Refer a friend and both of you get €20 off',
      },
    },

    pending: {
      title: 'Thank you - your order is being processed',
    },

    errors: {
      onePlusEventsWithoutEnoughTicketsError:
        'Our system has removed several items from your cart, for they are currently sold out. Please try to book for another date.',
      paymentFailed: 'The payment did not succeed. Please try again',
      // Most of these come from:
      // https://bitbucket.org/gokonfetti/backend/src/develop/source/app/Containers/CheckoutSection/Payment/README.md
      unauthenticated: 'You are not logged in. Please sign in again',
      gatewayUnauthorized:
        "The payment transaction wasn't authorized. Please try again",
      cardDeclined: 'The card was declined. Please try again',
      invalidGateway:
        'There was a problem with your payment. Please refresh the page and try again',
      invalidPaymentMethod:
        'There was a problem with your payment. Please refresh the page and try again',
      invalidPaymentSignature:
        'There was a problem with your payment. Please refresh the page and try again',
      invalidValueCaptured:
        "The total price doesn't seem correct. Please check your cart and try again",
      invalidValueInformed:
        "The total price doesn't seem correct. Please check your cart and try again",
      invalidValueRefundedCaptured:
        'The refunded value is different from the transaction total, please refresh and try again',
      actionRequired:
        'An additional security step is necessary. Please follow the instructions that are shown',
      confirmationRequired:
        'An additional security step is necessary. Please confirm the transaction.',
    },

    allItemsRemoved: 'All items in your cart were removed. Redirecting...',

    stripePayment: {
      stripe3DAuth: {
        alerts: {
          succeeded: {
            title: 'Success',
            message: 'Confirmation succeeded!',
          },
          requires_action: {
            title: 'Error',
            message: 'Confirmation error, please try again.',
          },
          requires_payment_method: {
            title: 'Error',
            message: 'Payment method error, please try using a different card.',
          },
        },
      },
    },

    sessionVoucher: {
      successMessage:
        'Success! Your coupon has been applied. You save {amount}.',
      reminderMessage: 'Your {amount} discount is still available, redeem now',
      errorMessage: 'It was not possible to save the coupon code.',
      minimumOrderValueMessage:
        'You need to add {amount} more to qualify for the coupon.',
    },
  },
}
